module.exports = __webpack_public_path__ + "static/media/sopt26kz.6e9df70c.pdf";